(() => {
  const header = document.getElementById('shopify-section-header');
  if (header?.querySelector('[data-vorug-native-menu]')) {
    let previousY = Math.max(0, window.scrollY);
    let accumulated = 0;
    let scheduled = false;
    const reveal = () => header.classList.remove('vorug-header-hidden');
    const updateHeader = () => {
      scheduled = false;
      const y = Math.max(0, window.scrollY);
      const delta = y - previousY;
      previousY = y;
      const protectedState = header.contains(document.activeElement) ||
        header.querySelector('[aria-expanded="true"]') ||
        document.body.matches('.vn19-body-locked, .hidden, .quick-view-open');
      if (y <= header.offsetHeight || protectedState) {
        accumulated = 0;
        reveal();
        return;
      }
      accumulated = Math.sign(accumulated) === Math.sign(delta) ? accumulated + delta : delta;
      if (Math.abs(accumulated) >= 12) {
        header.classList.toggle('vorug-header-hidden', accumulated > 0);
        accumulated = 0;
      }
    };
    window.addEventListener('scroll', () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(updateHeader); }
    }, {passive: true});
    header.addEventListener('focusin', reveal);
    window.addEventListener('pageshow', reveal);
  }

  const decimal = value => Number(Number(value).toFixed(1)).toString();
  const formatSize = (source, metric) => {
    const clean = source.replace(/[′’]/g, "'").replace(/\s+/g, ' ').trim();
    const pair = clean.match(/^(\d+(?:\.\d+)?)\s*(mm|cm|m|ft|')?\s*[xX×]\s*(\d+(?:\.\d+)?)\s*(mm|cm|m|ft|')?$/);
    if (!pair) {
      const round = clean.match(/^(\d+(?:\.\d+)?)\s*(mm|cm|m|ft|')\s+diameter$/i);
      if (!round) return source;
      const centimetres = Number(round[1]) * {mm: .1, cm: 1, m: 100, ft: 30.48, "'": 30.48}[round[2].toLowerCase()];
      return metric ? `${decimal(centimetres)} cm diameter` : `${decimal(centimetres / 30.48)}' diameter`;
    }
    const unit = pair[4] || pair[2];
    if (!unit) return source;
    const factor = {mm: .1, cm: 1, m: 100, ft: 30.48, "'": 30.48}[unit];
    const firstFactor = {mm: .1, cm: 1, m: 100, ft: 30.48, "'": 30.48}[pair[2] || unit];
    const width = Number(pair[1]) * firstFactor;
    const height = Number(pair[3]) * factor;
    return metric ? `${decimal(width)} × ${decimal(height)} cm` : `${decimal(width / 30.48)}' × ${decimal(height / 30.48)}'`;
  };
  let unit = 'ft';
  try { unit = localStorage.getItem('vorug-size-unit') || unit; } catch {}
  const formatLabels = scope => {
    const metric = unit === 'm' || unit === 'cm';
    scope.querySelectorAll('[data-vorug-production-unit]').forEach(label => {
      label.textContent = metric ? 'Sizes in centimetres' : 'Sizes in feet';
    });
    scope.querySelectorAll('[data-vorug-production-size]').forEach(label => {
      const dimensions = label.dataset.vorugProductionSize.split(',');
      const values = dimensions.map(value => metric ? decimal(Number(value) * 30.48) : value);
      label.textContent = values.length === 1
        ? `${values[0]}${metric ? ' cm' : "'"} diameter`
        : metric ? `${values.join(' × ')} cm` : values.map(value => `${value}'`).join(' × ');
    });
    scope.querySelectorAll('[data-vorug-size-label]').forEach(label => {
      const original = label.dataset.vorugSizeSource || label.textContent.trim();
      label.dataset.vorugSizeSource = original;
      const formatted = formatSize(original, unit === 'm' || unit === 'cm');
      if (label.textContent !== formatted) label.textContent = formatted;
    });
  };
  formatLabels(document);
  document.addEventListener('vorug:size-unit-change', event => {
    unit = event.detail?.unit || 'ft';
    formatLabels(document);
  });
  document.querySelectorAll('#shopify-section-cart-drawer, cart-items').forEach(root => {
    new MutationObserver(() => formatLabels(root)).observe(root, {childList: true, subtree: true});
  });
})();
